// extracted by mini-css-extract-plugin
export default {"statusContainer":"VerifyAccount_statusContainer__+xQTt","status":"VerifyAccount_status__rP7jX"};